import { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import CheckToken from "../../_Login/CheckToken";
import { UserContext } from "../../App";
import CompassBanner from "../../Tools/CompassBanner";
import CompassLogo from "../../Tools/CompassLogo";

const OilerConfigrationBlank = () => {

    const [user, setUser] = useContext(UserContext);
    const navigate = useNavigate();
    const { id } = useParams();
    CheckToken(user["id"], user["token"]).then((result) => { if (!result) { setUser({}); navigate("/Login"); } });

    const [allowedDeviation, setAllowedDeviation] = useState(15);
    const [additionalRows, setAdditionalRows] = useState(0);

    const getToday = (e) => {
        const today = new Date();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        const year = String(today.getFullYear());

        return `${month}/${day}/${year}`;
    };

    const handlePrint = () => {
        window.print();
    };

    const handlePrintAdditionalRows = () => {
        setAdditionalRows(additionalRows + 8); // Add 10 more rows each time the button is clicked
    };

    const TestRow = () => {
        return (
            <tr>
                <td style={{ ...tdStyleSm, textAlign: "center" }}>
                    ________
                </td>
                <td style={{ ...tdStyleSm, textAlign: "center" }}>
                    ________
                </td>
                <td style={{ ...tdStyleSm, textAlign: "center" }}>
                    ________
                </td>
                <td style={{ ...tdStyleSm, textAlign: "center" }}>
                    ________
                </td>
                <td style={{ ...tdStyleSm, textAlign: "center" }}>
                    ________ (________)
                </td>
                <td style={{ ...tdStyleSm, textAlign: "center" }}>
                    ________ (________)
                </td>
            </tr>
        );
    };

    const thStyle = { padding: "8px", border: "1px solid black", width: "25%", textAlign: "left" };
    const tdStyle = { padding: "8px", border: "1px solid black", width: "25%", textAlign: "center" };

    const thStyleSm = { padding: "8px", border: "1px solid black", width: "10%", textAlign: "center" };
    const tdStyleSm = { padding: "8px", border: "1px solid black", width: "10%", textAlign: "center" };

    document.title = `Print - Blank Config Form`;

    return (
        <>
            <div className="body-content" style={{ marginTop: "25px", width: "1100px", margin: "auto", display: "flex", flexDirection: "column" }}>

                <div className="no-print" style={{ marginBottom: "8px", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                    <div>
                        <Link to={`/Oilers`} className="btn btn-default" style={{ width: "132px" }}>Back</Link>
                        <button onClick={handlePrint} className="btn btn-primary" style={{ width: "132px", marginLeft: "8px" }}>Print This Page</button>
                    </div>
                    <div>
                        <button onClick={handlePrintAdditionalRows} className="btn btn-outline-secondary" style={{ width: "200px", marginLeft: "8px" }}>Add Test rows ({72 + additionalRows})</button>
                    </div>
                </div>

                <div style={{ border: "1px solid black", textAlign: "center", padding: "8px" }}>
                    <CompassLogo />
                </div>

                <div style={{ color: "lightgray" }}>
                    <i>Report generated on {getToday()}</i>
                </div>

                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                    <h3>Electrostatic Oiler Unit Configuration & Tests</h3>
                    <span style={{ color: "red", fontWeight: "bold" }}><i>[CONFIDENTIAL]</i></span>
                </div>

                <div className="no-break" style={{ width: "98%", margin: "1%" }}>
                    <h4>Oiler Details</h4>
                    <table className="no-break table table-striped" style={{ border: "1px solid black", width: "100%", marginTop: "16px", marginTop: "24px" }}>
                        <tbody>
                            <tr>
                                <th style={thStyle}>Oiler ID</th>
                                <td style={tdStyle}></td>
                                <th style={thStyle}>Date Created</th>
                                <td style={tdStyle}></td>
                            </tr>
                            <tr>
                                <th style={thStyle}>Job Number</th>
                                <td style={tdStyle}></td>
                                <th style={thStyle}>Created By</th>
                                <td style={tdStyle}></td>
                            </tr>
                            <tr>
                                <th style={thStyle}># Test Points</th>
                                <td style={tdStyle}></td>
                                <th style={thStyle}>Infeed Sensor Distance <span style={{ color: "var(--bs-secondary)" }}>(in)</span></th>
                                <td style={tdStyle}></td>
                            </tr>
                            <tr>
                                <th style={thStyle} colSpan={1}>Oiler Notes</th>
                                <td style={{ ...tdStyle, height: "72px" }} colSpan={3}></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ width: "48%", margin: "1%" }}>
                        <h4>Customer Details</h4>
                        <table className="no-break table table-striped" style={{ border: "1px solid black", width: "100%", marginTop: "16px", marginTop: "24px" }}>
                            <tbody>
                                <tr>
                                    <th style={thStyle}>Customer Name</th>
                                    <td style={tdStyle}></td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>JB Customer ID</th>
                                    <td style={tdStyle}></td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>Customer Address</th>
                                    <td style={tdStyle}></td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>Customer City, State, Zip</th>
                                    <td style={tdStyle}></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div style={{ width: "48%", margin: "1%" }}>
                        <h4>Site Location</h4>
                        <table className="no-break table table-striped" style={{ border: "1px solid black", width: "100%", marginTop: "16px", marginTop: "24px" }}>
                            <tbody>
                                <tr>
                                    <th style={thStyle}>Site Name</th>
                                    <td style={tdStyle}></td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>Site Address</th>
                                    <td style={tdStyle}></td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>Site City, State, Zip</th>
                                    <td style={tdStyle}></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ width: "48%", margin: "1%" }}>
                        <h4>Configuration Details</h4>
                        <table className="no-break table table-striped" style={{ border: "1px solid black", width: "100%", marginTop: "16px", marginTop: "24px" }}>
                            <tbody>
                                <tr>
                                    <th style={thStyle}>Configuration ID</th>
                                    <td style={tdStyle}></td>
                                </tr>
                                <tr>
                                    <th style={thStyle}># Blanks</th>
                                    <td style={tdStyle}></td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>Customer Blank #</th>
                                    <td style={tdStyle}></td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>Length <span style={{ color: "var(--bs-secondary)" }}>(mm)</span></th>
                                    <td style={tdStyle}></td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>Width <span style={{ color: "var(--bs-secondary)" }}>(mm)</span></th>
                                    <td style={tdStyle}></td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>Speed <span style={{ color: "var(--bs-secondary)" }}>(fpm)</span></th>
                                    <td style={tdStyle}></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div style={{ width: "48%", margin: "1%" }}>
                        <h4>Oil</h4>
                        <table className="no-break table table-striped" style={{ border: "1px solid black", width: "100%", marginTop: "16px", marginTop: "24px" }}>
                            <tbody>
                                <tr>
                                    <th style={thStyle}>Coverage Target <span style={{ color: "var(--bs-secondary)" }}>(mg/sqft)</span></th>
                                    <td style={tdStyle}></td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>Oil Name</th>
                                    <td style={tdStyle}></td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>Oil Temp <span style={{ color: "var(--bs-secondary)" }}>(°C)</span></th>
                                    <td style={tdStyle}></td>
                                </tr>
                                <tr>
                                    <th style={thStyle}>Oil Viscosity <span style={{ color: "var(--bs-secondary)" }}>(cSt)</span></th>
                                    <td style={tdStyle}></td>
                                </tr>

                                <tr>
                                    <th style={thStyle} colSpan={1}>Oil Description</th>
                                    <td style={{ ...tdStyle, height: "72px" }} colSpan={3}></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="no-break" style={{ width: "98%", margin: "1%" }}>
                    <h4>Header Details</h4>
                    <table className="no-break" style={{ border: "1px solid black", width: "100%", marginTop: "16px", marginTop: "24px" }}>
                        <tbody>
                            <tr>
                                <td style={thStyle} colSpan={2}>
                                    <span style={{ fontWeight: "bold", fontSize: "20px" }}>
                                        Upper Header
                                    </span>
                                </td>
                                <th style={thStyle}>Flow SP <span style={{ color: "var(--bs-secondary)" }}>(cc/min)</span></th>
                                <td style={tdStyle}></td>
                            </tr>
                            <tr>
                                <th style={thStyle}>Outer Bar <span style={{ color: "var(--bs-secondary)" }}>(kV)</span></th>
                                <td style={tdStyle}>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Spray: </span>
                                            <span>________</span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Resting: </span>
                                            <span>________</span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Idle: </span>
                                            <span>________</span>
                                        </div>
                                    </div>
                                </td>
                                <th style={thStyle}>Center Bar <span style={{ color: "var(--bs-secondary)" }}>(kV)</span></th>
                                <td style={tdStyle}>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Spray: </span>
                                            <span>________</span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Resting: </span>
                                            <span>________</span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Idle: </span>
                                            <span>________</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th style={thStyle}>Nozzle <span style={{ color: "var(--bs-secondary)" }}>(kV)</span></th>
                                <td style={tdStyle}>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Spray: </span>
                                            <span>________</span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Resting: </span>
                                            <span>________</span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Idle: </span>
                                            <span>________</span>
                                        </div>
                                    </div>
                                </td>
                                <th style={thStyle}>Boost <span style={{ color: "var(--bs-secondary)" }}>(kV)</span></th>
                                <td style={tdStyle}>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Spray: </span>
                                            <span>________</span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Resting: </span>
                                            <span>________</span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Idle: </span>
                                            <span>________</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th style={thStyle}>High Voltage <span style={{ color: "var(--bs-secondary)" }}>(ms)</span></th>
                                <td style={tdStyle}>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>On Time: </span>
                                            <span>________</span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Off Time: </span>
                                            <span>________</span>
                                        </div>
                                    </div>
                                </td>
                                <th style={thStyle} colSpan={1}>Nozzle Times <span style={{ color: "var(--bs-secondary)" }}>(ms)</span></th>
                                <td style={tdStyle} colSpan={3}>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>On Time: </span>
                                            <span>________</span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Off Time: </span>
                                            <span>________</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <table className="no-break" style={{ border: "1px solid black", width: "100%", marginTop: "16px", marginTop: "24px" }}>
                        <tbody>
                            <tr>
                                <td style={thStyle} colSpan={2}>
                                    <span style={{ fontWeight: "bold", fontSize: "20px" }}>
                                        Lower Header
                                    </span>
                                </td>
                                <th style={thStyle}>Flow SP <span style={{ color: "var(--bs-secondary)" }}>(cc/min)</span></th>
                                <td style={tdStyle}></td>
                            </tr>
                            <tr>
                                <th style={thStyle}>Outer Bar <span style={{ color: "var(--bs-secondary)" }}>(kV)</span></th>
                                <td style={tdStyle}>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Spray: </span>
                                            <span>________</span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Resting: </span>
                                            <span>________</span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Idle: </span>
                                            <span>________</span>
                                        </div>
                                    </div>
                                </td>
                                <th style={thStyle}>Center Bar <span style={{ color: "var(--bs-secondary)" }}>(kV)</span></th>
                                <td style={tdStyle}>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Spray: </span>
                                            <span>________</span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Resting: </span>
                                            <span>________</span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Idle: </span>
                                            <span>________</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th style={thStyle}>Nozzle <span style={{ color: "var(--bs-secondary)" }}>(kV)</span></th>
                                <td style={tdStyle}>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Spray: </span>
                                            <span>________</span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Resting: </span>
                                            <span>________</span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Idle: </span>
                                            <span>________</span>
                                        </div>
                                    </div>
                                </td>
                                <th style={thStyle}>Boost <span style={{ color: "var(--bs-secondary)" }}>(kV)</span></th>
                                <td style={tdStyle}>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Spray: </span>
                                            <span>________</span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Resting: </span>
                                            <span>________</span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Idle: </span>
                                            <span>________</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th style={thStyle}>High Voltage <span style={{ color: "var(--bs-secondary)" }}>(ms)</span></th>
                                <td style={tdStyle}>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>On Time: </span>
                                            <span>________</span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Off Time: </span>
                                            <span>________</span>
                                        </div>
                                    </div>
                                </td>
                                <th style={thStyle} colSpan={1}>Nozzle Times <span style={{ color: "var(--bs-secondary)" }}>(ms)</span></th>
                                <td style={tdStyle} colSpan={3}>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>On Time: </span>
                                            <span>________</span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span>Off Time: </span>
                                            <span>________</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>

                <div className="" style={{ width: "98%", margin: "1%" }}>
                    <h4>Tests</h4>

                    <table className="table" style={{ border: "1px solid black", width: "100%", marginTop: "24px" }}>
                        <thead>
                            <tr>
                                <th style={thStyleSm}>Position</th>
                                <th style={thStyleSm}>Blank #</th>
                                <th style={thStyleSm}>Test #</th>
                                <th style={thStyleSm}>Coverage Target <span style={{ color: "var(--bs-secondary)" }}>(mg/sqft)</span></th>
                                <th style={thStyleSm}>Top Value / ±Deviation <span style={{ color: "var(--bs-secondary)" }}>(mg/sqft)</span></th>
                                <th style={thStyleSm}>Bottom Value / ±Deviation <span style={{ color: "var(--bs-secondary)" }}>(mg/sqft)</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                Array.from(Array(72 + additionalRows).keys()).map((index) => {
                                    return <TestRow key={index} />;
                                })
                            }
                        </tbody>
                    </table>

                    <div className="no-print" style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
                        <button onClick={handlePrintAdditionalRows} className="btn btn-outline-secondary" style={{ width: "200px", marginLeft: "8px" }}>Add Test rows ({72 + additionalRows})</button>
                    </div>

                </div>

                <div className="no-break" style={{ width: "98%", margin: "1%" }}>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly", marginTop: "24px" }}>
                        <h5><i>Tests Completed By: ________________________</i></h5>
                        <h5><i>Date Completed: ________________</i></h5>
                        <h5><i>Digitally Recorded By: ________________________</i></h5>
                        <h5><i>Digitally Recorded On: ________________</i></h5>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly", marginTop: "24px" }}>

                    </div>
                </div>

            </div>
        </>
    );
}

export default OilerConfigrationBlank;
